(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.AmexPerksConfig = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports = {
  production: {
    amex: {
      mode: "production",
      campaignUuid: "6e00f66d-0a5b-4534-9e82-9c6af84aea00",
      merchantApiKey: "76b3f472e14849d8af886f1bac3fbf4f",
      marketplaceCampaignUuid: "fddd0d7f-2efa-47b4-876c-a6aa5498bbef",
      returnUrl: "https://www.americanexpress.com/en-us/benefits/perks/entertainment/6-months/"
    },
    variantId: '39739717648487'
  },
  qa: {
    amex: {
      mode: "qa",
      campaignUuid: "d5839790-1b42-4c5f-90a2-314888d01172",
      merchantApiKey: "b3968fd175e745658e4e362349f3da84",
      marketplaceCampaignUuid: "8a6be984-68e6-4e14-976c-5fd22ba4a050",
      returnUrl: "https://qwww.americanexpress.com/en-us/benefits/perks/entertainment/6-months/"
    },
    variantId: '39689327673415'
  }
}

},{}]},{},[1])(1)
});
